import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=71ce4c16&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=ts"
export * from "./CartFooter.vue?vue&type=script&lang=ts"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=71ce4c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce4c16",
  null
  
)

export default component.exports